import React, { FC } from 'react';

import { Money, UuidResult } from '../../../../api-client';
import { createOfferPurchaseManager } from '../../../../di';
import { useAppDispatch, useNavigateByName } from '../../../../hooks';
import { set } from '../../../../store/overlay';
import { subtractBalance } from '../../../../store/profile';
import { RouteDictionary, sleep } from '../../../../utils';
import SmsConfirmation from '../../../confirmation/SmsConfirmation';
import { ConfirmSmsCodeForm } from '../../utils';
import Modal from '../Modal';
import { ModalProps } from '../Modal/Modal';

//TODO: REWORK TO ONE UUID
interface Props extends ModalProps {
  purchaseConfirmation: {
    offerUuid: string;
    confirmationUuid: string;
    money: Money;
  };
}

const PurchaseConfirmationModal: FC<Props> = ({ active, onClose, purchaseConfirmation }) => {
  const navigate = useNavigateByName();
  const dispatch = useAppDispatch();
  const sendCode = async (smsCode: string): Promise<UuidResult> => {
    const manager = await createOfferPurchaseManager();
    return await manager.create(
      purchaseConfirmation.offerUuid,
      purchaseConfirmation.confirmationUuid,
      smsCode
    );
  };

  const resendCode = async (): Promise<void> => {
    await sleep(3000);
  };

  const onSuccess = async (): Promise<void> => {
    dispatch(subtractBalance(purchaseConfirmation.money.amount));
    //FIX: OVERLAY IS NOT CLOSED WHEN MODEL IS, ADD MESSAGE THAT INVESTMENT IS CONFIRMED
    dispatch(set(false));
    navigate(RouteDictionary.MY_PROJECTS);
  };
  return (
    <Modal active={active} onClose={onClose}>
      <SmsConfirmation header="Подтверждение" onClose={onClose}>
        <ConfirmSmsCodeForm
          sendCallback={sendCode}
          resendCallback={resendCode}
          successCallback={onSuccess}
          prefix="offer-conf"
        />
      </SmsConfirmation>
    </Modal>
  );
};

export default PurchaseConfirmationModal;
